import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk, RootState } from '../store';
import { cloneDeep } from 'lodash';
import { Customer, getCustomer, updateCustomer } from '../../api/customer';
import { getSiteCustomer } from '../../api/site';
import { CustomerSlice, EditCustomerSlice } from './types';

const initialState: Array<CustomerSlice> = [
  {
    id: 1,
    customer_id: null,
    account_id: null,
    name: '',
    address: '',
    logo_uri: '',
    saved: false
  }
];

export const customersSlice = createSlice({
  name: 'customers',
  initialState,
  reducers: {
    loadCustomers: (state, action: PayloadAction<Customer[]>) => {
      let id = 0;
      return action.payload.map((customer, index) => {
        let combined = { 
          ...cloneDeep(customer),
          saved: true,
          id: id++
        }
        return combined
      })
    },
    editCustomer: (state, action: PayloadAction<EditCustomerSlice>) => {
      const customer = state.find(customer => customer.id === action.payload.id)
      
      if (typeof action.payload.name != 'undefined') {
        customer.name = action.payload.name;
      }
      if (typeof action.payload.address != 'undefined') {
        customer.address = action.payload.address;
      }
      if (typeof action.payload.logo != 'undefined') {
        customer.logo = action.payload.logo;
      }
      if (typeof action.payload.logo_uri != 'undefined') {
        customer.logo_uri = action.payload.logo_uri;
      }
      
      customer.saved = false;
      if (typeof action.payload.saved != 'undefined') {
        customer.saved = action.payload.saved;
      }
    },
  }
});

export const { loadCustomers, editCustomer } = customersSlice.actions;

export const fetchCustomer = (station_id: number, site_id: number): AppThunk => async (dispatch, getState) => {
  const { user } = getState()
  
  try {
    const site_customer = await getSiteCustomer(user.api_key, site_id)
    
    // If there are not existing customers create a placeholder
    if (site_customer == null) {
      
    } else {
      
      const customer = await getCustomer(user.api_key, site_customer.customer_id)
      dispatch(loadCustomers([customer]));
    }

  } catch (err) {
    console.error(err.toString())
  }
}

export const saveCustomer = (id: number): AppThunk => async (dispatch, getState) => {
  const { user, customers } = getState()
  
  const customer = customers.filter((customer) => customer.id === id)[0]
  
  try {
    var data: any = { customer_id: customer.customer_id, name: customer.name, address: customer.address }
    if (typeof customer.logo !== 'undefined') {
      data = { customer_id: customer.customer_id, name: customer.name, address: customer.address, logo: customer.logo }
    }
    
    const result = await updateCustomer(user.api_key, data)
    dispatch(editCustomer({ id: customer.id, saved: true, logo_uri: result.logo_uri || null, logo: null }))

  } catch (err) {
    console.error(err.toString())
  }
}

export const saveLogo = (id: number, logo: File): AppThunk => async (dispatch, getState) => {
  const { user, customers } = getState()
  
  const customer = customers.filter((customer) => customer.id === id)[0]
  
  try {
    const result = await updateCustomer(user.api_key, { customer_id: customer.customer_id, name: customer.name, address: customer.address, logo: logo })
    dispatch(editCustomer({ id: customer.id, saved: true, logo_uri: result.logo_uri || null, logo: null }))
  } catch (err) {
    console.error(err.toString())
  }
}

export const selectCustomer = (state: RootState) => {
  // return state.customers.map(customer => ({...customer}))[0];
  return state.customers[0];
}

export default customersSlice.reducer;
